import React, { useState } from "react"
import "./styles.css";
import { Formik, Field, Form } from 'formik'
import * as Yup from 'yup'
import { validationMessages } from '@valid/config'
import { Button, ButtonsContainer, TextInput, Select } from '@valid/components'
const UserModal = props => {

  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const { modalRef, isModalOpen, onModalClose, user, handleSubmit, edit, } = props;
  const validationSchema = Yup.object().shape({
    username: Yup.string().min(5).required(validationMessages.required),
    email: Yup.string().email().required(validationMessages.required),
    name: Yup.string().required(validationMessages.required),
  })

  const initialValues = user ? {
    _id: user._id,
    name: user.name,
    username: user.username,
    email: user.email,
    level: user.level
  } : {
      name: '',
      username: '',
      email: '',
      level: 'user'
    }

  const containerVariants = {
    initial: { y: 0, opacity: 0 },
    formInitial: { y: -40, opacity: 0 },
    formAnimate: { y: 0, opacity: 1 },
  }

  return (
    <>
      <div ref={modalRef} className={`${isModalOpen ? "show" : ""} modal-overlay`} onClick={() => onModalClose ? onModalClose() : {}} />
      <div ref={modalRef} className={`${isModalOpen ? "show" : ""} modal`}>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => handleSubmit(values, edit)}
        >
          {(props) => {
            return (
              <Form
                className="form"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSubmit(props.values, edit)
                  }
                }}
              >
                <Field
                  name="name"
                  label="Nome Completo"
                  component={TextInput}
                />
                <Field
                  name="username"
                  label="Username"
                  component={TextInput}
                />
                <Field
                  name="email"
                  label="E-mail"
                  component={TextInput}
                />
                <div>
                  <Select
                    label="Nível"
                    field={{ name: "level" }}
                    form={props}
                    options={[
                      { value: 'admin', label: 'Administrador' }, { value: 'user', label: 'Usuário' }]
                    }
                    labeltype=""
                  ></Select>
                </div>

                { error && <div className="form__error">{error}</div>}

                <ButtonsContainer>
                  <Button
                    onClick={(values) => { props.handleSubmit(values, edit) }}
                    loading={loading}
                    variant="primary"
                    fullWidth
                  >
                    {edit ? "Editar" : "Cadastrar"}
                  </Button>
                </ButtonsContainer>
              </Form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}

export default UserModal;
